import { render, staticRenderFns } from "./MeritReport.vue?vue&type=template&id=3fcc3b01"
import script from "./MeritReport.vue?vue&type=script&lang=js"
export * from "./MeritReport.vue?vue&type=script&lang=js"
import style0 from "./MeritReport.vue?vue&type=style&index=0&id=3fcc3b01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports